import { render } from "./NykCheckbox.vue?vue&type=template&id=20e427c3"
import script from "./NykCheckbox.vue?vue&type=script&lang=js"
export * from "./NykCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__